import Dashboard from './dashboard.js';

export default Dashboard;